import { Info } from "lucide-react";
import { useRef } from "react";

import useSpotlight from "../../../../hooks/useSpotlight";

/**
 * Small inline "i" button that opens a native dialog with technical detail
 * copy. Meant to sit right after an Eyebrow label.
 *
 * @param {Object} props - Tech note props.
 * @param {string} props.children - Technical detail body text.
 * @returns {JSX.Element} Tech note trigger + dialog.
 */
const TechNote = ({ children }) => {
  const dialogRef = useRef(null);
  const { cardRef, handleMouseMove, handleMouseLeave } = useSpotlight();

  const openDialog = () => dialogRef.current?.showModal();
  const closeDialog = () => dialogRef.current?.close();

  const handleBackdropClick = (event) => {
    if (event.target === dialogRef.current) closeDialog();
  };

  return (
    <>
      <button
        type="button"
        className="hiw-info-btn"
        aria-label="Technical details"
        onClick={openDialog}
      >
        <Info size={14} strokeWidth={1.25} />
      </button>
      <dialog ref={dialogRef} className="hiw-tech-dialog" onClick={handleBackdropClick}>
        <div
          ref={cardRef}
          className="hiw-dialog-inner"
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
        >
          <div className="spotlight-overlay">
            <div className="spotlight-gradient" />
          </div>
          <div className="hiw-dialog-inner__content">
            <button type="button" className="hiw-dialog-close" onClick={closeDialog} aria-label="Close">
              ✕
            </button>
            <span className="hiw-dialog-label">Technical detail</span>
            <div className="hiw-dialog-body">
              <p>{children}</p>
            </div>
          </div>
        </div>
      </dialog>
    </>
  );
};

export default TechNote;
